/**
 * GlassCard - Glass morphism card component with neon border glow on hover
 */
import { Card, CardProps } from 'tamagui';

interface GlassCardProps extends CardProps {
  /** Enable neon glow effect on hover */
  glowOnHover?: boolean;
  /** Use terminal style instead of glass */
  terminal?: boolean;
}

export function GlassCard({
  glowOnHover = true,
  terminal = false,
  children,
  ...props
}: GlassCardProps) {
  if (terminal) {
    return (
      <Card
        backgroundColor="$backgroundHover"
        borderWidth={1}
        borderColor="$borderColor"
        padding="$4"
        borderRadius="$3"
        hoverStyle={glowOnHover ? {
          borderColor: '$green10',
          scale: 1.01,
        } : undefined}
        {...props}
      >
        {children}
      </Card>
    );
  }

  return (
    <Card
      backgroundColor="transparent"
      borderWidth={1}
      borderColor="$borderColor"
      padding="$4"
      borderRadius="$3"
      hoverStyle={glowOnHover ? {
        borderColor: '$green10',
        scale: 1.01,
      } : undefined}
      {...props}
    >
      {children}
    </Card>
  );
}
